import { Outlet } from "react-router-dom";
import Info from "../components/common/info";
import { useState, useEffect, useRef } from "react";
import BuyGoodsDisclaimer from "../components/common/bg-disclaimer";


const UpsellDownsellLayout = () => {
    const [showModal, setShowModal] = useState(false);
    const modalShownCount = useRef(0);

    useEffect(() => {
        const handleMouseOut = (e: MouseEvent) => {
            if (e.clientY < 0 && modalShownCount.current < 2) {
                modalShownCount.current += 1;
                setShowModal(true);
            }
        };

        window.addEventListener('mouseout', handleMouseOut);
        return () => window.removeEventListener('mouseout', handleMouseOut);
    }, []);

    return (
        <>
            <Outlet />
            <Info />
            <BuyGoodsDisclaimer />
            {showModal && (
                <section id="go-back-modal">
                    <div className="gg-modal">
                        <div className="container-fluid">
                            <div className="row align-items-center justify-content-center text-center">
                                <div className="col-md-6 col-10 gg-modal-content">
                                    <div className="row align-items-center justify-content-center pt-3">
                                        <div className="col-11 gg-bg-solid-blue gg-border-radius text-white">
                                            <h2 className="text-uppercase">Wait! Don't go away!</h2>
                                        </div>
                                    </div>
                                    <div className="row align-items-center justify-content-center pt-3">
                                        <div className="col-11">
                                            <p className="fs-5 lh-1">Closing this page or hitting the back button will <b>cause errors</b> in your order!</p>
                                            <p className="fs-5">Click <b>"Stay on Page"</b>, finish reading and <b>make your choice on this page</b> with the buttons and links available.</p>
                                        </div>
                                        <button onClick={() => setShowModal(false)} className="btn gg-button-buy-green gg-buy-card-button gg-bigger-button mb-3 fs-5 fw-bold">Stay on Page</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>
            )}
        </>
    )
};

export default UpsellDownsellLayout;